import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate, Outlet } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";

/**
 * Leagues V2 is a gated Production Beta behind the LaunchDarkly `leaguesV2`
 * flag. The guard fails neutral rather than open: the V2 route mounts only on
 * an explicit `true`, an explicit `false` (a non-beta user) redirects out to
 * the dashboard, and while the flag is still resolving (`undefined`) we hold on
 * a neutral loading state instead of rendering V2. That keeps a non-beta user
 * hitting a direct `/leagues/...` URL from briefly mounting the feature (and
 * firing its API requests) before the flag resolves, while beta users simply
 * wait out the flag decision rather than being bounced mid-hydration. The nav
 * entry is gated on the same flag so it stays hidden until the flag is truthy.
 */
export function LeaguesV2RouteGuard() {
  const { leaguesV2 } = useFlags();

  if (leaguesV2 === undefined) {
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <Spinner className="size-6 text-text-muted" />
      </div>
    );
  }

  if (!leaguesV2) return <Navigate to="/dashboard" replace />;

  // The whole feature's scope for the new button palette (see [data-leagues]
  // in index.css). `contents` so the wrapper adds no box of its own; custom
  // properties still inherit through it.
  return (
    <div data-leagues className="contents">
      <Outlet />
    </div>
  );
}
